import Head from "next/head";
import Image from "next/image";
import React from "react";
import { constants } from "../constants";
import TributeTree from "../public/Tribute tree_28x.jpg";

export default function AboutPage() {
    return (
        <>
            <Head>
                <title>About - {constants.siteTitle}</title>
            </Head>
            <div className="relative h-96">
                <Image
                    src={TributeTree}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="50% 10%"
                    className="filter brightness-60"
                    alt=''
                />
                <div className="relative mx-auto container flex flex-col h-full items-center justify-center py-12">
                    <h1 className="text-5xl text-white">
                        About Light up a Life...
                    </h1>
                    <h2 className="text-3xl text-white">a place to remember</h2>
                </div>
            </div>
            <div className="mx-auto container max-w-prose my-12 text-gray-700 space-y-4">
                <div className="mx-auto text-xl leading-relaxed space-y-8">
                    <p>
                        Welcome to Light up a Life… a place to remember, where
                        you can create a personal online tribute to keep a loved
                        one close at heart. Share favourite memories, treasured
                        photos and keep their light shining brightly by inviting
                        family, friends and colleagues to add to their personal
                        tribute page.
                    </p>
                    <p>
                        At St Oswald&apos;s Hospice, we know how important it is
                        to celebrate life. When someone we love dies, we never
                        move on, but we can still move forward with our lives
                        without leaving them behind. Maintaining an enduring
                        connection is an important part of the grieving process
                        They continue to live in our hearts and our head as we
                        remember the good times, mark anniversaries, share silly
                        moments and take comfort when things feel tough.
                    </p>
                    <p>
                        Creating an online tribute page for your loved ones
                        means that there is always somewhere to share that
                        memory, the words that pop into your head when you think
                        of them or a favourite photo. We hope it brings you
                        comfort.
                    </p>
                    <p>
                        <strong className="font-semibold">
                            It&apos;s your place, their place, it&apos;s a place
                            to remember.
                        </strong>
                    </p>
                </div>
            </div>
        </>
    );
}
